import { forwardRef } from 'react';
import { SnackbarContent, CustomContentProps, useSnackbar } from 'notistack';
import { IconClose } from '../Icon/Index';

const CustomSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  (props, ref) => {
    const { id, message, variant } = props;
    const { closeSnackbar } = useSnackbar();

    const handleDismiss = () => {
      closeSnackbar(id);
    };

    return (
      <SnackbarContent ref={ref} role='alert'>
        <div className={`theme-snackbar theme-snackbar-${variant}`}>
          <span>
            <div dangerouslySetInnerHTML={{ __html: message ?? '' }} />
          </span>
          <IconClose
            className='theme-snackbar-close-button'
            fill='#fff'
            onClick={handleDismiss}
          />
        </div>
      </SnackbarContent>
    );
  },
);

export default CustomSnackbar;
